import type { Risk } from "@/data/mock";

const styles: Record<Risk, string> = {
  high: "bg-risk-high/15 text-risk-high border border-risk-high/30",
  medium: "bg-risk-medium/15 text-risk-medium border border-risk-medium/30",
  low: "bg-risk-low/15 text-risk-low border border-risk-low/30",
};

export function RiskPill({ level, className }: { level: Risk; className?: string }) {
  return (
    <span className={`inline-flex items-center rounded px-2 py-0.5 text-[10px] font-semibold tracking-[0.12em] uppercase ${styles[level]} ${className ?? ""}`}>
      {level}
    </span>
  );
}